import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import s from '../../services/allservices.jsx';
import '../../stylesheet/friends.css';
import LoaderSmall from "../loader/loadersmall.jsx";
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js'
const JSEncrypt = window.JSEncrypt
const styles = {
    button: {
        // margin: 12,
        marginTop: 20,
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    friendsState: state.getFriendsReducer.friendsState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchFriends() {
        dispatch(
            actions.getFriendsAction()
        )
    }
})
class AddByCardNo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardNumber: "",
            confirmCardNumber:"",
            message: "",
            nickName: "",
            userDetailState: {},
            disabled: true,
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleAccordion = this.handleAccordion.bind(this)
    }

    onChange = (e) => this.setState({ [e.target.name]: e.target.value }, () => {
        if (this.state.cardNumber !== "" && this.state.confirmCardNumber !== "" && this.state.nickName !== "") {

            this.setState({
                disabled: false
            })
        }
        else {
            this.setState({
                disabled: true
            })
        }

    })
    cancelCourse = () => {
        setTimeout(function () {
            window.location.reload(1);
        }, 100);
    }
    handleAccordion() {
        // let accord= document.getElementById("accactive")
        // accord.classList.add("active")
    }
    isNumberKey = (e) => {
        var charCode = e.keyCode;

        //You condition
        if (charCode === 58) {

            e.preventDefault();

            return false;
        }
    }

    handleBasic() {
        this.setState({
            basic: !this.state.basic
        })
    }
    handleSubmit() {
        const { publicKey } = this.props
        this.setState({
            loader: true,
            disabled : true,
        })
        let token = "Token " + localStorage.getItem('token')
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                accountId: encrypt.encrypt(localStorage.getItem("accountId")),
                cardNumber: encrypt.encrypt(this.state.cardNumber),
                message: this.state.message === "" ? this.state.message : encrypt.encrypt(this.state.message),
                nickName: encrypt.encrypt(this.state.nickName),
                cardDetailsId: ""
            }
            let _this = this
            let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
            let traceId = getClientId();
            fetch(plink + s.add_friend, {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': token,
                    'X-Trace-Id': traceId,
                    'X-KlickEx-Client':buildClientHeader(),
                }),
                body: JSON.stringify(state)
            })
                .then(
                    function (response) {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {
                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            _this.setState({
                                loader: false
                            })
                            _this.props.fetchFriends();
                        }
                        else if (response.status === 422) {
                            let message = response.headers.get('message')
                            toast.error(message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 60
                            })
                            _this.setState({
                                loader: false
                            })
                        }
                        else {
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });

                            _this.setState({
                                loader: false
                            })

                        }
                    })
        }
    }
    render() {
        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            
                            <div className="col-sm-12 " >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Card Number"
                                    onInput={(e) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, 16)
                                    }}
                                    name="cardNumber"
                                    type="number"
                                    autoComplete='none'
                                    onKeyPress={this.isNumberKey}
                                    maxLength="16"
                                    onChange={this.onChange}
                                    className="my-className no-spinners input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-12 " >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Confirm Card Number"
                                    type="number"
                                    maxLength="16"

                                    onInput={(e) => {
                                        e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, 16)
                                    }}
                                    onKeyPress={this.isNumberKey}
                                    name="confirmCardNumber"
                                    autoComplete='none'
                                    onChange={this.onChange}
                                    className="my-className input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >

                            <div className="col-sm-12 " >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText="Nickname"
                                    type="text"
                                    name="nickName"
                                    autoComplete='off'
                                    maxLength="50"
                                    onChange={this.onChange}
                                    className="my-className input-width required"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="col-sm-6">
                        <div className="row input-group" >
                            <div className="col-sm-12 " >
                                <TextField
                                    hintText="Typing"
                                    floatingLabelText={"Message"}
                                    type="text"
                                    name="message"
                                    autoComplete='none'
                                    maxLength="50"
                                    onChange={this.onChange}
                                    className="my-className input-width"
                                    underlineFocusStyle={styles.focusStyle}
                                    floatingLabelFocusStyle={styles.focusTextStyle}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6 pb-5">
                        <RaisedButton
                            label="Add Card"
                            disabled={this.state.disabled}
                            onClick={this.handleSubmit}
                            className="btn-std mr-3"
                            backgroundColor="#ed8f40"
                            labelColor="#115876"
                            style={{ minWidth: "50px", marginTop: "20px" , borderRadius :"6px"}}
                        />
                        <RaisedButton
                            label="Cancel"
                            name="cancelCourse"
                            value="cancel"
                            onClick={this.cancelCourse}
                            style={styles.button}
                            className="btn-std"
                            backgroundColor="#ed8f40"
                            labelColor="#115876"
                            buttonStyle={{ borderRadius: 6 }}
                        />                        
                    </div>
                    <div className="col-sm-2">

                    </div>
                    {this.state.loader === true &&
                        <div className="col-sm-2" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                            <LoaderSmall />
                        </div>}
                </div>
            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddByCardNo);


// WEBPACK FOOTER //
// ./src/components/friends/addbycardno.jsx